import React from 'react';
import { CorporateFormWrapper } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormWrapper/CorporateFormWrapper';
import { FirmInformationSection } from 'src/components/enterprise/features/Corporate/components/Form/FirmInformationSection/FirmInformationSection';
import { FeaturesSection } from 'src/components/enterprise/features/Corporate/components/Form/FeaturesSection/FeaturesSection';
import { InvoiceInformationSection } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceInformationSection/InvoiceInformationSection';
import { CorporateFormProps } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { CorporateFormFooter } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormFooter/CorporateFormFooter';
import { CorporateFormProvider } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/CorporateFormProvider';
import { InvoiceContactSection } from './InvoiceContactSection/InvoiceContactSection';

export const CorporateForm: React.FC<CorporateFormProps> = ({
  corpData,
  onSubmit,
  defaultValues,
  isEditPage,
  isParentPage,
}) => {
  return (
    <CorporateFormProvider
      isEditPage={isEditPage}
      corpData={corpData}
      isParentPage={isParentPage}
    >
      <CorporateFormWrapper defaultValues={defaultValues}>
        <FirmInformationSection />
        <FeaturesSection />
        <InvoiceInformationSection />
        <InvoiceContactSection />
        <CorporateFormFooter onSubmit={onSubmit} />
      </CorporateFormWrapper>
    </CorporateFormProvider>
  );
};
